import { useQuery } from "@tanstack/react-query";
import { fetchTeamMembers, teamMemberService, TeamMember } from "@/api/teamMembers";

export function useTeamMemberByFirstName(
  organizationId: string,
  firstName: string
) {
  return useQuery<TeamMember | null, Error>({
    queryKey: ["teamMember", organizationId, firstName],
    queryFn: () =>
      teamMemberService.getTeamMemberByFirstName(organizationId, firstName),
    enabled: !!organizationId && !!firstName,
  });
}

export function useTeamMembers(organizationId: string) {
  return useQuery<TeamMember[], Error>({
    queryKey: ["teamMembers", organizationId],
    queryFn: () => fetchTeamMembers(organizationId),
    enabled: !!organizationId,
  });
}
